import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import TabsMui from '@mui/material/Tabs'
import TabMui from '@mui/material/Tab'
import styled from 'styled-components'

const Tabs = styled(TabsMui)`
  flex: 1;
  display: inline-flex;
  background: #f5f5f5;

  && {
    min-height: 44px;
  }

  .MuiTabs-scroller {
    overflow-x: auto !important;
  }

  .MuiTabs-flexContainer {
    gap: 8px;
  }
`
const Tab = styled(TabMui)`
  && {
    padding: 12px 16px;
    min-height: 44px;
    min-width: auto;
    font-size: 14px;
    font-weight: 500;
    text-transform: none;
  }
`

const NavigationTabs = () => {
  const { id, view } = useParams()
  const navigate = useNavigate()
  const [tab, setTab] = useState(view || 'profile')

  // Sync tab state with URL param
  useEffect(() => {
    if (view) {
      setTab(view)
    }
  }, [view])

  const handleChange = (_e, newTab) => {
    setTab(newTab)
    navigate(`/v2/patient/${id}/${newTab}`)
  }

  return (
    <Tabs
      value={tab}
      className="patient-navigation"
      onChange={handleChange}
      aria-label="nav tabs"
      variant="scrollable"
      scrollButtons={false}
    >
      <Tab value="profile" label="Profile" />
      <Tab value="treatment" label="Treatment" />
      <Tab value="insurance" label="Insurance" />
      <Tab value="documents" label="Documents" />
      <Tab value="imaging" label="Imaging" />
      <Tab value="finance" label="Finance" />
    </Tabs>
  )
}

export default NavigationTabs
